const adminAppValidations = (title, link) => {
  const errors = {};

  if (!title || title.trim() === "") {
    errors.title = "FirstName cannot be empty.";
  }

  if (!link || link.trim() === "") {
    errors.link = "LastName  cannot be empty.";
  }

  return errors;
};

export default adminAppValidations;
